import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { envConfigs } from '@config/envConfigs';
import { apiServerGet, apiServerPut } from '@common/axios.services';
import { IUpdateUserProfilePreferenceRequest, IUserProfilePreferences } from './userProfilePreferences.models';

export const apiRoutes = {
  userProfilePreferences: '/UserProfilePreferences',
  userProfilePreferencesWithId: (id: number) => `/UserProfilePreferences/${id}`,
};

export const getUserProfilePreferencesAsync = async (): Promise<IPagedResultsV1<IUserProfilePreferences>> => {
  const result = await apiServerGet<IPagedResultsV1<IUserProfilePreferences>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.userProfilePreferences}`,
  );
  return result.data;
};

export const updateProjectTransmittalAsync = async (
  request: IUpdateUserProfilePreferenceRequest,
): Promise<IItemResponse<IUserProfilePreferences>> => {
  const result = await apiServerPut<IItemResponse<IUserProfilePreferences>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.userProfilePreferencesWithId(request.id)}`,
    { ...request },
  );
  return result.data;
};
